import { render, staticRenderFns } from "./TicketRequest.vue?vue&type=template&id=5fd4f945&scoped=true&"
import script from "./TicketRequest.vue?vue&type=script&lang=ts&"
export * from "./TicketRequest.vue?vue&type=script&lang=ts&"
import style0 from "./TicketRequest.vue?vue&type=style&index=0&id=5fd4f945&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4f945",
  null
  
)

export default component.exports